export enum BatchType {
  Pipeline = 'Pipeline',
  Release = 'Release',
  PsIntegration = 'PsIntegration'
}
